export const add = {
  hour: {
    hourAfter: { rule: true, message: "L'heure de début doit précéder l'heure de fin" }
  },
  contact: {
    required: {
      rule: true, message: 'Vous devez choisir un participant'
    }
  },
  firstintervenant_id: {
    required: {
      rule: true, message: 'Vous devez choisir un intervenant'
    }
  }
}

export const edit = {
  hour: {
    hourAfter: { rule: true, message: "L'heure de début doit précéder l'heure de fin" }
  },
  contact: {
    required: {
      rule: true, message: 'Vous devez choisir un participant'
    }
  },
  firstintervenant_id: {
    required: {
      rule: true, message: 'Vous devez choisir un intervenant'
    }
  }
}



// WEBPACK FOOTER //
// ./src/validations/meetings.js